import { createCategory, createCategoryTooltipController } from './category';
import { createCategoryController } from './category/categoryController';
import { createLegendListController } from './common';
import { createTrendTooltipController } from './trend/tooltip';
import { createTrendController } from './trend/trendController';
import { createTrend } from './trend/trendProvider';
export function createCharts(config, enhancer) {
    return create({
        ...config,
        provider: {
            createTrendController: createTrendController,
            createTrendTooltipController: createTrendTooltipController,
            createCategoryController: createCategoryController,
            createCategoryTooltipController: createCategoryTooltipController,
            createLegendListController: createLegendListController,
        },
    }, enhancer);
}
function create(config, enhancer) {
    if (enhancer) {
        return enhancer(create)(config);
    }
    return {
        createTrend(trendConfig) {
            const controllerConfig = {
                options: trendConfig.options,
                strategy: config.strategy,
            };
            const fragment = {
                legend: {
                    controller: config.provider.createLegendListController(),
                },
                tooltip: {
                    controller: {
                        category: config.provider.createCategoryTooltipController(controllerConfig),
                        trend: config.provider.createTrendTooltipController(controllerConfig),
                    },
                },
            };
            const controller = config.provider.createTrendController(controllerConfig, fragment);
            return createTrend(trendConfig, controller);
        },
        createCategory(categoryConfig) {
            const controllerConfig = {
                options: categoryConfig.options,
                strategy: config.strategy,
            };
            const fragment = {
                legend: {
                    controller: config.provider.createLegendListController(),
                },
                tooltip: {
                    controller: {
                        category: config.provider.createCategoryTooltipController(controllerConfig),
                        trend: config.provider.createTrendTooltipController(controllerConfig),
                    },
                },
            };
            const controller = config.provider.createCategoryController(controllerConfig, fragment);
            return createCategory(categoryConfig, controller);
        },
    };
}
//# sourceMappingURL=chakraChartProvider.js.map